import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;
declare function initiateMediaUsage(): any;

@Component({
  selector: 'app-questionpreview',
  templateUrl: './questionpreview.html',
  styleUrls: ['./questionpreview.scss']
})
export class QuestionPreviewComponent {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;
  public ckeConfig: any;
  public isLoaded: boolean = false;

  private loadMediaUsageSub : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ]
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';


    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    var previewParam = this.generalSvc.getUrlParam("qid");
    if(previewParam !== null && previewParam !== undefined && previewParam !== ""){
      this.dataSvc.buildQuestionPreview(previewParam);
    }
    else
      window.location.href = "login";


    var previewInterval = setInterval(() => {
      try {
        if (this.dataSvc.previewLoaded){
          this.isLoaded = true;
          this.checkAccordions();
          clearInterval(previewInterval);
        }
      }catch(e) {

      }
    }, 1000);

  }


  openCloseThis(id) {
    var content = document.getElementById(id).parentElement;
    var collapse = content.querySelector('.collapse');
    var itag = content.querySelector("i");
    if(collapse.classList.contains('in')){
      collapse.classList.remove('in');
      itag.classList.add("glyphicon-plus");
      itag.classList.remove("glyphicon-minus");
    }
    else{
      collapse.classList.add('in');
      itag.classList.remove("glyphicon-plus");
      itag.classList.add("glyphicon-minus");
    }
    this.checkAccordions();
}

checkAccordions(){
  var openCounter = 0;
  var closedCounter = 0;
  for(var i = 1; i < 4; i++){
    try{
      var content = document.getElementById('htmlCardHeader' + i).parentElement;
      var collapse = content.querySelector('.collapse');
      if(collapse.classList.contains('in')){
        openCounter++;
      }
      else{
        closedCounter++;
      }
    }
    catch(ex){}
    
  }
  if(closedCounter === 0){
    this.allClosed = false;
  }
  else{
    this.allClosed = true;
  }
  
}

closeAll(){
  try{
    this.close('htmlCardHeader1');
  }
  catch(ex){}try{
    this.close('htmlCardHeader2');
  }
  catch(ex){}try{
    this.close('htmlCardHeader3');
  }
  catch(ex){}
  
  this.allClosed = true;
  
}

openAll(){
  try{
    this.open('htmlCardHeader1');
  }
  catch(ex){}try{
    this.open('htmlCardHeader2');
  }
  catch(ex){}try{
    this.open('htmlCardHeader3');
  }
  catch(ex){}
  this.allClosed = false;
}

close(id){
  var content = document.getElementById(id).parentElement;
  var collapse = content.querySelector('.collapse');
    collapse.classList.remove('in');
    var itag = content.querySelector("i");
    sessionStorage.setItem("acc_" + this.questionId + "_" + id, "out");
    itag.classList.add("glyphicon-plus");
    itag.classList.remove("glyphicon-minus");
  
}

open(id){
  var content = document.getElementById(id).parentElement;
  var collapse = content.querySelector('.collapse');
    collapse.classList.add('in');
    var itag = content.querySelector("i");
    itag.classList.remove("glyphicon-plus");
    itag.classList.add("glyphicon-minus");
    sessionStorage.setItem("acc_" + this.questionId + "_" + id, "in");  
}

  
  getQuestionText() {
    var qTxt = this.dataSvc.currentQuestion().Question.QuestionText;
    if(qTxt == null || qTxt == undefined)
      qTxt = this.dataSvc.currentQuestion().Question.Text;
    return qTxt;
  }
}
